import type { ButtonBaseProps } from '@platform/ui';
import type { ReactNode } from 'react';

export type BannerVariant = 'error' | 'warning' | 'info';

export type BannerScope = 'global' | string[];

export interface BannerAction extends ButtonBaseProps {
  /** Stable React key; must not depend on mutable text like a countdown. */
  id: string;
  label: string;
  ariaLabel?: string;
  onClick?: () => void;
}

export interface BannerDefinition {
  id: string;
  variant: BannerVariant;
  scope: BannerScope;
  /** When true, the banner cannot be dismissed by the user. */
  persistent: boolean;
  title?: string;
  description: ReactNode;
  action?: BannerAction[];
}

/** Priority order for sorting: lower = higher priority. */
export const VARIANT_PRIORITY: Record<BannerVariant, number> = {
  error: 0,
  warning: 1,
  info: 2,
};
